import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

type SanitizedHtmlProps = React.HTMLAttributes<HTMLElement> & {
  as?: 'div' | 'span' | 'p' | 'h4';
  html: string;
};

const SanitizedHtml: React.FC<SanitizedHtmlProps> = ({ as: Tag = 'div', html, ...rest }) => {
  const sanitized = useMemo(() => DOMPurify.sanitize(html, { USE_PROFILES: { html: true } }), [html]);
  // eslint-disable-next-line react/no-danger
  return <Tag {...rest} dangerouslySetInnerHTML={{ __html: sanitized }} />;
};

export default SanitizedHtml;
